import React from "react"

import BasePermissionGate, { BasePermissionGateProps } from "@/components/PermissionGate/BasePermissionGate"

const TeamGroupPermissionGate = (props: Omit<BasePermissionGateProps<"team">, "feature">) => {
	return (
		<BasePermissionGate
			{...props}
			feature="team"
		/>
	)
}

export default TeamGroupPermissionGate
